import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Play, Sparkles } from "lucide-react";
import heroImage from "@/assets/hero-image.jpg";
import * as Sentry from '@sentry/react';

const HeroSection = () => {
  const scrollToSamples = () => {
    document.getElementById("themes")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden bg-gradient-to-br from-[hsl(25,95%,63%,0.1)] via-[hsl(340,82%,76%,0.1)] to-[hsl(270,67%,72%,0.1)]">
      <div className="container mx-auto max-w-6xl relative z-10">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Text Content */}
          <div className="text-center md:text-left space-y-6">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[hsl(340,82%,76%,0.3)] to-[hsl(270,67%,72%,0.3)] text-foreground px-4 py-2 rounded-full text-sm font-medium border border-[hsl(340,82%,76%,0.3)]">
              <Sparkles className="w-4 h-4 text-[hsl(var(--playful-pink))]" />
              <span>Try Free Stories – No Card Needed</span>
              <span className="animate-bounce-gentle">🎉</span>
            </div>

            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
              <span className="bg-gradient-to-r from-[hsl(var(--playful-orange))] via-[hsl(var(--playful-pink))] to-[hsl(var(--playful-purple))] bg-clip-text text-transparent">
                Magical Audio Stories
              </span>{" "}
              <span className="text-foreground">Personalized for Your Child</span>
            </h1>

            <p className="text-lg md:text-xl text-muted-foreground">
              Teach kindness, good habits, gratitude & more — through fun stories with your child as the hero. ✨
            </p>

            <div className="flex flex-col sm:flex-row gap-3 justify-center md:justify-start">
              <Link to="/auth">
                <Button
                  size="lg"
                  className="w-full sm:w-auto text-base h-14 px-8 bg-gradient-to-r from-[hsl(var(--playful-orange))] to-[hsl(var(--playful-pink))] hover:opacity-90 transition-all shadow-lg hover:shadow-xl hover:scale-105 text-white font-semibold rounded-full"
                >
                  <span className="mr-2">🚀</span>
                  Try for Free
                </Button>
                
              </Link>
              {/* <Button
                variant="outline"
                size="lg"
                className="w-full sm:w-auto text-base h-14 px-6 rounded-full border-2 border-[hsl(var(--playful-purple))] text-[hsl(var(--playful-purple))] hover:bg-[hsl(var(--playful-purple),0.1)] transition-all"
                onClick={scrollToSamples}
              >
                <Play className="w-4 h-4 mr-2" />
                Listen to a Sample
              </Button> */}
            </div>

            <p className="text-sm text-muted-foreground flex items-center justify-center md:justify-start gap-2">
              <span className="text-[hsl(var(--playful-yellow))]">⭐⭐⭐⭐⭐</span>
              Trusted by 10,000+ parents
            </p>
          </div>

          {/* Illustration */}
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-[hsl(var(--playful-pink),0.3)] via-[hsl(var(--playful-purple),0.2)] to-[hsl(var(--playful-teal),0.3)] rounded-[3rem] blur-3xl" />
            <div className="relative aspect-square rounded-2xl shadow-lg overflow-hidden">
              <img
                src={heroImage}
                alt="Father and child listening to stories together"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
